import { useState } from "react";
import { Row, Col, Form, Container, Button } from "react-bootstrap";

const Ask = () => {
  const [isLoading, setIsLoading] = useState(false); // Состояние для управления загрузкой

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true); // Устанавливаем состояние загрузки
    const formData = new FormData(e.target);
    const name = formData.get('name');
    const tel = formData.get('tel');
    const email = formData.get('email');
    const message = formData.get('message');

    // Регулярные выражения для проверки
    const phoneRegex = /^\+?[78][-(]?\d{3}\)?[-]?\d{3}[-]?\d{2}[-]?\d{2}$/; // Для российских номеров
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Проверка данных
    if (!name.trim()) {
      alert('Пожалуйста, введите ваше имя.');
      setIsLoading(false);
      return;
    }
    if (!phoneRegex.test(tel)) {
      alert('Пожалуйста, введите корректный номер телефона.');
      setIsLoading(false);
      return;
    }
    if (!emailRegex.test(email)) {
      alert('Пожалуйста, введите корректный адрес электронной почты.');
      setIsLoading(false); // Сбрасываем состояние загрузки
      return;
    }

    const data = { name, tel, email, message, type: 'ask' };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}api/send-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        alert('Заявка успешно отправлена!');
      } else {
        alert('Ошибка при отправке заявки.');
      }
    } catch (error) {
      console.error('Ошибка:', error);
      alert('Произошла ошибка при отправке.');
    } finally {
      setIsLoading(false); // Сбрасываем состояние загрузки
    }
  };

  return (
    <Container style={{ maxWidth: '1200px', paddingTop: "40px" }}>
      <div style={{  backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '10px'}}>
        <Row className="mt-2">
          <Col md={6}>
            <Form onSubmit={handleSubmit} className="form_container">
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label
                  style={{ fontSize: '24px', fontWeight: 'bold', textAlign: 'center' }}>
                  Если у вас остались вопросы по поводу заказа
                </Form.Label>
                <Form.Label
                  style={{ fontSize: '16px', textAlign: 'center', display: 'block', padding: '10px' }}>
                  Оставьте заявку на сайте, и мы с вами свяжемся в ближайшее время
                </Form.Label>
                <Form.Control className="mb-3 service_input" type="text" name="name" placeholder="Ваше имя" />
                <Form.Control className="mb-3 service_input" type="tel" name="tel" placeholder="Ваш телефон" />
                <Form.Control className="mb-3 service_input" type="email" name="email" placeholder="Ваша почта" />
                <Form.Control
                  className="mb-3 service_input"
                  type="text"
                  as="textarea"
                  name="message"
                  placeholder="Ваше сообщение"
                  rows={4}
                  style={{ resize: 'none' }}
                />
                <div className="d-grid gap-2">
                  <Button
                    type="submit"
                    className="service_button"
                    variant="custom"
                    size="lg"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Загрузка...' : 'Отправить заявку'}
                  </Button>
                </div>
              </Form.Group>
            </Form>
          </Col>
          <Col className="pogruz_img" md={6}></Col>
        </Row>
      </div>
    </Container>
  );
};

export default Ask;